import { toast, Toast } from 'react-hot-toast';

export interface ToastOptions {
  duration?: number;
  position?: Toast['position'];
  icon?: string;
  ariaProps?: {
    role: 'status' | 'alert';
    'aria-live': 'polite' | 'assertive';
  };
}

export function useToast() {
  const showToast = (
    message: string,
    type: 'success' | 'error' | 'info' = 'success',
    options?: ToastOptions
  ) => {
    const defaultOptions: ToastOptions = {
      duration: 3000,
      position: 'top-center',
      ariaProps: {
        role: 'status',
        'aria-live': 'polite',
      },
      ...options,
    };

    switch (type) {
      case 'success':
        return toast.success(message, defaultOptions);
      case 'error':
        return toast.error(message, defaultOptions);
      case 'info':
        return toast(message, defaultOptions);
      default:
        return toast(message, defaultOptions);
    }
  };

  return { showToast };
}

export type { Toast };
export { toast } from 'react-hot-toast';
